import React, {useState, useEffect, useRef} from 'react';
import {ReactComponent as ManagerSVG} from 'assets/images/characters/manager.svg';
import './manager.scss';

const Manager = () => {
	/* Blinking */
	const blinkTimeout = useRef(null);
	const timeout = useRef(null);

	const minBlinkTime = 1000;
	const maxBlinkTime = 4000;

	const [eyesAreClosed, setEyesAreClosed] = useState(false);

	const blink = () => {
		const randomInterval = Math.round(Math.random() * (maxBlinkTime - minBlinkTime)) + minBlinkTime;
		if (blinkTimeout.current) clearTimeout(blinkTimeout.current);
		blinkTimeout.current = setTimeout(() => {
			/* Close eyes */
			setEyesAreClosed(true);

			if (timeout.current) clearTimeout(timeout.current);
			timeout.current = setTimeout(() => {
				/* Open eyes */
				setEyesAreClosed(false);
				clearTimeout(timeout.current);
				
				/* Repeat loop with new random */
				blink();
			}, 100);
		}, randomInterval);
	};

	/**
	 * Component did mount / will unmount
	 */
	useEffect(() => {
		blink();
		
		return () => {
			/* Component will unmount */
			if (blinkTimeout.current) clearTimeout(blinkTimeout.current);
			if (timeout.current) clearTimeout(timeout.current);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className={'Manager ' + (eyesAreClosed ? ' blinking' : '')}>
			<ManagerSVG />
		</div>
	);
};

export default Manager;
